















































































































































































































































































































import Vue from "vue";
import * as api from "@/api";
import moment from "moment";
import { transform } from "@/utils/iBuildingTool";
import { CommitInfo, downloadFile, FileData, taskFilesItem, TaskNoticesItem, TaskUserCommitsItem } from "@/api"; // ConverStatus
import { uploadFile } from "@/utils/upload-file";
import { Message } from "element-ui";
// import { UploadFileModal } from '../../components/uploadFileModal.vue';
// import { FILEURL } from '@/utils/preview-helper';
import { Base64 } from "@/utils/base64";
import { convertModel, getConvertProgress } from "@/api/model-view";
import { checkModelConvertStatus } from "@/utils/check-model-convert";
import UploadFileModal from "../../components/uploadFileModal.vue";
import TaskModelViewer from "../../components/task-model-viewer.vue";
import NoticeModal from "../../components/notice-modal.vue";
import { ConverStatus, TaskFile } from "./types";
import StanderModalTableList from "./stander-modal-table-list.vue";
import DataUploadModal from "./DataUploadModal.vue";

export default Vue.extend({
    components: {
    UploadFileModal,
    TaskModelViewer,
    NoticeModal,
    StanderModalTableList,
    DataUploadModal
},
    data() {
        return {
            tabList: [
                { name: "作业资料", index: 1, isActive: true },
                { name: "标准模型", index: 2, isActive: false },
                { name: "提交作业", index: 3, isActive: false }
            ],
            isActive: true,
            searchFile: null,
            currentIndex: 1,
            hiddenButton: true,
            queryParams: {
                taskId: "",
                isTaskRule: false,
                isLocked: false,
                skipCount: 0,
                filter: null,
                maxResultCount: 100
            },
            querynoticeParams: {
                taskId: "",
                skipCount: 0,
                maxResultCount: 999
            },
            queryCheckRecordList: {
                taskId: "",
                skipCount: 0,
                maxResultCount: 100
            },
            modelViewVisible: false,
            fileModalVisible: false,
            viewFile: {} as Partial<TaskFile>,
            tableData: [] as any[],
            checkRecordList: [] as any[],
            noticeList: [] as TaskNoticesItem[],
            modalNoticeList: [] as TaskNoticesItem[],
            noticeTotalCount: 0,
            moreNoticeModalIsVisable: false, // 控制加载更多通知内容弹框显示
            convertModalLoading: false,
            opinionVisible: false, // 意见弹窗
            review: "", // 意见
            taskName: "", // 作业名称
            // 上传所需参数
            extensions: [
                ".rvt",
                ".stl",
                ".obj",
                ".rfa",
                ".fbx",
                ".rft",
                ".dgn",
                ".sat",
                ".skp",
                ".3ds",
                ".3mf",
                ".dae",
                ".gim",
                ".ifc",
                ".dxf",
                ".dwg",
                ".pdf",
                ".doc",
                ".docx",
                ".xls",
                ".xlsx",
                ".ppt",
                ".pptx",
                ".png",
                ".jpg",
                ".jpeg",
                ".gif",
                ".txt"
            ],
            sessionId: "",
            precision: 0, // 上传精度
            onlyStandard: false, // 是否为标准模型
            uploadFileModalVisible: false, // 上传弹窗是否显示
            uploadDataFileModalVisible: false, // 上传弹窗是否显示
            fileList: [] as FileData[],
            dataFileList: [] as FileData[],
            isDrawings: false, // 是否为图纸文件
            uploadComplete: false,
            uploadDataComplete: false,
            dataUploadComplete: false,
            convertError: false,
            convertProgress: 0,
            convertProgressText: ""
        };
    },
    computed: {
        isExpired(): boolean {
            return this.$route.query.expired === "1";
        },
        filteredTableData(): api.taskFilesItem[] {
            return this.tableData.filter(item => {
                return item.uploadFile?.fileName.indexOf(this.searchFile || '') !== -1;
            });
        },
        hasModel(): boolean {
            return (!!this.checkRecordList.length && !this.checkRecordList?.[0]?.isDataFile);
        }
    },
    created() {
        this.getSessionId();
        this.taskName = this.$route.query.taskName.toString();
        this.queryParams.taskId = JSON.parse(JSON.stringify(this.$route.query.taskId));
        // this.taskName = this.$route.params
        this.getTaskFileList(false);
        this.getNoticeList(2);
    },
    filters: {
        formatTime(val: Date) {
            return moment(val).format("YYYY.MM.DD HH:mm:ss");
        }
    },
    methods: {
        openUploadModal() {
            this.fileList = [];
            this.convertError = false;
            this.convertProgress = 0;
            this.convertProgressText = "";
            this.uploadComplete = false;
            this.uploadFileModalVisible = true;
        },
        openUploadDataModal() {
            this.dataFileList = [];
            this.uploadDataComplete = false;
            this.uploadDataFileModalVisible = true;
        },
        jump() {
            this.$router.back();
        },
        async switchTab(e) {
            if (e.index === 1) {
                this.tabList[0].isActive = true;
                this.tabList[1].isActive = false;
                this.tabList[2].isActive = false;

                this.getTaskFileList(false);
                this.getNoticeList(2);
            }
            if (e.index === 2) {
                this.tabList[0].isActive = false;
                this.tabList[1].isActive = true;
                this.tabList[2].isActive = false;
                await this.getTaskFileList(true);
            }
            if (e.index === 3) {
                this.tabList[0].isActive = false;
                this.tabList[1].isActive = false;
                this.tabList[2].isActive = true;

                await this.getCheckRecordList();
            }
            // e.isActive = !e.isActive;
            this.currentIndex = e.index;
        },
        // 获取sessionId
        async getSessionId() {
            const res = await api.getSessionId();
            if (!api.error(res)) {
                // this.sessionId
                console.log(res);
                this.sessionId = res.data;
            }
        },
        // 获取作业资料
        async getTaskFileList(e) {
            this.queryParams.taskId = JSON.parse(JSON.stringify(this.$route.query.taskId));
            this.queryParams.isTaskRule = e;
            const res = await api.myTasks_files(this.queryParams);
            if (!api.error(res)) {
                res.data.items.forEach(x => {
                    x.uploadFile.creationTime = moment(x.uploadFile.creationTime).format(
                        "YYYY-MM-DD HH:mm:ss"
                    );
                    x.uploadFile.fileSize = transform(x.uploadFile.fileSize);
                });

                this.tableData = res.data.items;
            }
        },
        // 获取通知内容
        async getNoticeList(maxResultCount: number) {
            // params 获取总条数
            // this.noticeList = [];
            this.querynoticeParams.taskId = JSON.parse(JSON.stringify(this.$route.query.taskId));
            this.querynoticeParams.maxResultCount = maxResultCount;
            const res = await api.MyTaskNotices(this.querynoticeParams);
            if (res && !api.error(res)) {
                if (res.data.items.length === 2) {
                    // debugger;
                    this.modalNoticeList = res.data.items;
                    this.noticeList = res.data.items;
                } else if (res.data.items.length < 2) {
                    res.data.items.forEach(x => {
                        x.creationTime = moment(x.creationTime).format("YYYY.MM.DD HH:mm:ss");
                    });
                    this.noticeList = res.data.items;
                } else {
                    this.modalNoticeList = res.data.items;
                }

                this.noticeTotalCount = res.data.totalCount;
                // console.log(this.noticeList);
            }
        },
        // 获取提交的作业记录
        async getCheckRecordList() {
            this.queryCheckRecordList.taskId = JSON.parse(JSON.stringify(this.$route.query.taskId));
            const res = await api.MyTaskUserCommits_Page(this.queryCheckRecordList);
            if (!api.error(res)) {
                if (res.data.items.length === 0) {
                    this.hiddenButton = true;
                } else {
                    this.hiddenButton = res.data.items[0].commitInfo.status !== 2;
                }

                res.data.items.forEach(x => {
                    x.commitInfo.creationTime = x.commitInfo.creationTime
                        ? moment(x.commitInfo.creationTime).format("YYYY-MM-DD HH:mm:ss")
                        : null;
                    x.commitInfo.lastCheckTime = x.commitInfo.lastCheckTime
                        ? moment(x.commitInfo.lastCheckTime).format("YYYY-MM-DD HH:mm:ss")
                        : null;
                });

                console.log(res.data.items);
                this.checkRecordList = (res.data.items as any).map(v => {
                    if (v.uploadFile) {
                    return { ...v };
                }
                    return {
                         ...v,
                         uploadFile: {
                            fileName: '资料',
                        fileId: 0,
                        id: 0,
                    }
                 };
                });
                console.log('checkRecordList', this.checkRecordList, this.hiddenButton);
                this.convertModel();

                this.getDataFile();
            }
        },
        checkCorrect(item: TaskUserCommitsItem) {
            this.viewFile = item;
            this.modelViewVisible = true;
        },
        removeTask(item: TaskUserCommitsItem) {
            this.$confirm("确认要删除此作业吗？", {
                callback: async () => {
                    const res = await api.DeleteCommit({
                        commitId: item.commitInfo.id,
                        taskId: item.commitFile.taskId
                    });
                    if (res && !api.error(res)) {
                        this.getCheckRecordList();
                    } else {
                        Message.error(res.error.message);
                    }
                }
            });
        },
        async viewReviewReport(item) {
            window.open(item.checkReportInfo?.errorFileUrl, "__blank");
        },
        // 查看
        async view(item: TaskFile) {
            this.isDrawings = item.uploadFile.fileExtention === ".dwg";
            if ([".rvt", "rvt", ".dwg", ".ifc"].includes(item.uploadFile.fileExtention)) {
                const convertRes = await checkModelConvertStatus(item.uploadFile.fileId);
                if (convertRes) {
                    const { href } = this.$router.resolve({
                        path: `/model-view?id=${item.uploadFile.fileId}&draw=${this.isDrawings
                            }&rightmenu=${[".rvt", "rvt"].includes(item.uploadFile.fileExtention)}`
                    });
                    window.open(href, "_blank");
                }
            } else {
                // 文件预览还没做好....貌似预览服务出了一点问题，当遇到非rvt文件 点击查看或者filename直接下载。
                const url = `https://spdcore.test.spdio.com/${item.uploadFile.fileUrl}?authorization=Bearer%20${this.sessionId}&fullfilename=${item.uploadFile.fileName}`;
                item.uploadFile.fileUrl = `${process.env.VUE_APP_PREVIEWURL
                    }/onlinePreview?url=${encodeURIComponent(Base64.encode(url))}&watermarkTxt=${this.$store.state.user.nickName
                    }`;
                // item.uploadFile.fileUrl = FILEURL(item.uploadFile.fileUrl);

                window.open(item.uploadFile.fileUrl, "_blank");
                // this.download(item.taskFile.id);
                // this.$message.warning('当前文件暂时无法打开，请下载后查阅');
            }
        },
        handleCancel() {
            if (this.uploadComplete && this.convertProgress !== 100 && !this.convertError) {
                this.$confirm("当前模型还未转换完成，确认要取消吗？").then(() => {
                    this.fileList = [];
                    this.convertError = false;
                    this.convertProgress = 0;
                    this.convertProgressText = "";
                    this.uploadComplete = false;
                    this.uploadFileModalVisible = false;
                });
            } else {
                this.fileList = [];
                this.convertError = false;
                this.convertProgress = 0;
                this.convertProgressText = "";
                this.uploadComplete = false;
                this.uploadFileModalVisible = false;
            }
        },
        handleDataUploadModalCancel() {
            this.dataFileList = [];
            this.dataUploadComplete = false;
            this.uploadDataFileModalVisible = false;
        },
        async handleFileUploadChange(_file) {
            const file = _file.raw;
            this.fileList = [...this.fileList, _file];
            const setFile = async data => {
                const { percentage, filePath, fileId, error } = data;
                this.fileList = this.fileList.map(v => {
                    if (v.uid === _file.uid) {
                        return {
                            ...v,
                            percentage: percentage ?? v.percentage,
                            filePath: filePath ?? v.filePath,
                            fileId: fileId ?? v.fileId,
                            error: error ?? v.error
                        };
                    }
                    return v;
                });
                if (percentage === "100") {
                    this.uploadComplete = true;
                    const res: any = await convertModel(this.fileList[0].fileId);
                    if (res.status.error !== 0) {
                        console.log("发起转换失败");
                        this.convertError = true;
                        return;
                    }
                    if (res.convertStatus === 0) {
                        console.log("模型已经转换完成");
                        this.convertProgress = 100;
                        return;
                    }
                    if (res.convertStatus === 1) {
                        const timer = setInterval(async () => {
                            const convertProgressRes: any = await getConvertProgress(
                                this.fileList[0].fileId
                            );
                            if (convertProgressRes.status.error !== 0) {
                                console.log("查询转换进度失败");
                                this.convertError = true;
                                clearInterval(timer);
                                return;
                            }
                            if (convertProgressRes.convertStatus === 0) {
                                console.log("转换完成");
                                this.convertProgress = 100;
                                clearInterval(timer);
                                return;
                            }
                            if (convertProgressRes.convertStatus === 0) {
                                if (convertProgressRes.progressDesc !== this.convertProgressText) {
                                    this.convertProgress = Math.min(99, this.convertProgress + 10);
                                }
                                this.convertProgressText = convertProgressRes.progressDesc;
                            }
                        }, 1000);
                    }
                }
            };
            // this.file = setFile;
            uploadFile(file, setFile, this.sessionId);
        },
        handleDataFileUploadChange(_file) {
            const file = _file.raw;
            this.dataFileList = [...this.dataFileList, _file];
            const setFile = async data => {
                const { percentage, filePath, fileId, error } = data;
                this.dataFileList = this.dataFileList.map(v => {
                    if (v.uid === _file.uid) {
                        return {
                            ...v,
                            percentage: percentage ?? v.percentage,
                            filePath: filePath ?? v.filePath,
                            fileId: fileId ?? v.fileId,
                            error: error ?? v.error
                        };
                    }
                    return v;
                });
                if (percentage === "100") {
                    this.dataUploadComplete = true;
                }
            };
            // this.file = setFile;
            uploadFile(file, setFile, this.sessionId);
        },
        handleUploadFileDelete(uid) {
            this.fileList = [];
            this.convertError = false;
            this.convertProgress = 0;
            this.convertProgressText = "";
            this.uploadComplete = false;
        },
        handleDataUploadFileDelete(uid) {
            this.dataFileList.splice(this.dataFileList.findIndex(v => v.uid === uid), 1);
            this.dataUploadComplete = false;
        },
        async handleUploadFileConfirm() {
            // let promises = new Promise
            const promises: Promise<any>[] = this.fileList
                .filter(v => !v.error)
                .map(v =>
                    api.uploadFiles_Save({
                        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                        fileId: v.fileId!,
                        fileName: v.name,
                        fileExtention: v.name.substring(v.name.lastIndexOf(".")),
                        // fileTaskId: this.task.id,
                        fileConvertState: 2,
                        fileSize: v.size,
                        fileUrl: v.filePath ?? "",
                        modelGroupId: "00000000-0000-0000-0000-000000000000",
                        type: 2
                    })
                );
            const res = await Promise.all(promises);
            if (res.every(v => v && !api.error(v))) {
                this.uploadFileModalVisible = false;
                this.fileList = [];
                // this.$message.success('保存成功');
                // 如果有模型上传，不是只有资料上传
                this.submitMyCheck({ uploadFileId: res?.[0]?.data });
            }
        },
        async handleDataUploadFileConfirm() {
            const dataPromises: Promise<any>[] = this.dataFileList
                .filter(v => !v.error)
                .map(v =>
                    api.uploadFiles_Save({
                        // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                        fileId: v.fileId!,
                        fileName: v.name,
                        fileExtention: v.name.substring(v.name.lastIndexOf(".")),
                        fileTaskId: JSON.parse(JSON.stringify(this.$route.query.taskId)),
                        fileConvertState: 2,
                        fileSize: v.size,
                        fileUrl: v.filePath ?? "",
                        modelGroupId: "00000000-0000-0000-0000-000000000000",
                        type: 5
                    })
                );
            const dataRes = await Promise.all(dataPromises);
            if (dataRes.every(v => v && !api.error(v))) {
                this.uploadDataFileModalVisible = false;
                this.dataFileList = [];
                this.getCheckRecordList();
                // this.$message.success('保存成功');
                // 如果有模型上传，不是只有资料上传
                console.log('dataRes', dataRes);
                // this.submitDataFile({taskFile:,uploadFile:,})
            }
        },
        async pollConvertStatus(file: Partial<TaskFile>) {
            const timer = setInterval(async () => {
                const res: any = await api.getConvertProgress(
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    { fileId: file.uploadFile?.fileId! },
                    this.sessionId
                );
                // 转换进度成功，清空定时器，将file状态改为success
                if (res.status.error === 0 && res.convertStatus === 0) {
                    clearInterval(timer);
                    this.CheckReport(file);
                    this.getCheckRecordList();
                    // this.setFileConvertStatus(file, ConverStatus.success);
                }
                // 转换进度失败，清空定时器，将file状态改为fail
                if (res.status.error !== 0) {
                    clearInterval(timer);
                    // this.
                    this.convertModalLoading = true;
                    // this.setFileConvertStatus(file, ConverStatus.fail);
                }
            }, 4000);
        },
        async CheckReport(file: Partial<TaskUserCommitsItem>) {
            await api.checkReport({ taskCommitId: file.commitInfo?.id, userId: file.userId });
            // if (!api.error(res)) {
            //     console.log(res);
            // }
        },
        async convertModel() {
            // 找到未转换成功的模型文件
            const notSuccessConvertFiles = this.checkRecordList.filter(
                v =>
                    v.uploadFile?.fileExtention === ".rvt" &&
                    v.uploadFile.fileConvertState !== ConverStatus.success
            );
            notSuccessConvertFiles.forEach(async v => {
                await api
                    .getConvertProgress({ fileId: v.uploadFile?.fileId }, this.sessionId)
                    .then(async (res: any) => {
                        // 首次查询文件进度，还未开始转换
                        if (res.status.error === 20012) {
                            // 发起转换

                            const convertRes: any = await api.convertModel(
                                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                                { fileId: v.uploadFile?.fileId!, tessLevel: this.precision },
                                this.sessionId
                            );
                            // 转换发起成功
                            if (convertRes.status.error === 0) {
                                // 修改file状态为inProgress
                                // this.setFileConvertStatus(v, ConverStatus.inProgress);
                                // 轮询转换进度
                                this.pollConvertStatus(v);
                            }
                            return;
                        }
                        //  首次查询文件进度，已经转换成功
                        if (res.status.error === 0 && res.convertStatus === 0) {
                            // 将file状态改为success
                            this.convertModalLoading = false;
                            if (v.uploadFile?.fileConvertState !== ConverStatus.success) {
                                // this.setFileConvertStatus(v, ConverStatus.success);
                                v.uploadFile.fileConvertState = ConverStatus.success;
                            }
                            return;
                        }
                        //  首次查询文件进度，文件正在转换
                        if (res.convertStatus === 1) {
                            this.pollConvertStatus(v);
                            return;
                        }
                        //  首次查询文件进度，文件转换失败
                        if (res.status.error !== 0) {
                            // 将file状态改为fail
                            // this.setFileConvertStatus(v, ConverStatus.fail);
                            v.uploadFile.fileConvertState = ConverStatus.fail;
                        }
                    });
            });
        },

        // 提交作业
        async submitMyCheck({ uploadFileId, attachFileIdList }: {uploadFileId: number; attachFileIdList?: number[]}) {
            // debugger;
            const res = await api.MyTaskCommitSubmit({
                taskId: JSON.parse(JSON.stringify(this.$route.query.taskId)),
                uploadFileId,
                attachFileIdList
            });
            if (!api.error(res)) {
                this.getCheckRecordList();
                const commitId = res.data;
                if (commitId) {
                    await api.checkReport({
                        taskCommitId: commitId,
                        userId: this.$store.state.user.userId
                    });
                }
            } else {
                this.$message.error(res.error.message);
            }
        },
        // 提交作业资料
        async submitDataFile(payload: {taskFile: any; uploadFile: any }) {
            // debugger;
            const res = await api.submitDataFile({
                taskId: JSON.parse(JSON.stringify(this.$route.query.taskId)),
                taskFile: payload.taskFile,
                uploadFile: payload.uploadFile
            });
            // if (!api.error(res)) {

            // } else {
            //     this.$message.error(res.error.message);
            // }
        },
        // 重新提交
        recheck(e) {
            console.log(e);
            this.submitMyCheck({ uploadFileId: e.uploadFile.id });
        },

        // 加载更多通知
        loadMore() {
            this.getNoticeList(999);
            this.moreNoticeModalIsVisable = true;
        },
        // 下载资料
        async download(id) {
            const currentFile = this.tableData.find(v => v.taskFile?.id === id);
            const res: any = await api.downloadFile(
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                { fileId: currentFile?.uploadFile?.fileId! },
                this.sessionId
            );
            const blob = new Blob([res], { type: "application/octet-stream" });
            const reader = new FileReader();
            reader.onload = e => {
                // eslint-disable-next-line quotes
                const a = document.createElement("a");
                const fileName = currentFile?.uploadFile?.fileName;
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                a.download = decodeURIComponent(fileName!);
                a.href = e.target?.result as string;
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
            };
            reader.readAsDataURL(blob);
        },
        checkOpinion(e) {
            this.review = e;
            this.opinionVisible = true;
        },
        async getDataFile() {
            const res: any = await api.QueryMyUploadFiles({
                type: 5,
                 taskId: JSON.parse(JSON.stringify(this.$route.query.taskId)),
                 maxResultCount: 999,
                 skipCount: 0
                 });
            // console.log(, 'res');
            this.checkRecordList.push(...res.data.items.map(v => {
                return {
                    ...v,
                    creationTime: moment(v.creationTime).format("YYYY-MM-DD HH:mm:ss"),
                    isDataFile: true
                };
            }));
        },
        async downloadDataFile(item) {
            const res: any = await downloadFile({ fileId: item.fileId }, this.sessionId);
            const blob = new Blob([res], { type: "application/octet-stream" });
            const reader = new FileReader();
            reader.onload = e => {
                // eslint-disable-next-line quotes
                const a = document.createElement("a");
                const { fileName } = item;
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                a.download = decodeURIComponent(fileName!);
                a.href = e.target?.result as string;
                document.body.appendChild(a);
                a.click();
                document.body.removeChild(a);
            };
            reader.readAsDataURL(blob);
        },
        async removeDataFile(item) {
            this.$confirm("确认要删除此资料吗？", {
                callback: async () => {
                    const res = await api.TaskFilesRemove({ id: item.id });
                    if (res && !api.error(res)) {
                        this.getCheckRecordList();
                    } else {
                        Message.error(res.error.message);
                    }
                }
            });
        }
    }
});
